<template>
  <base-container ref="container">
    <el-divider></el-divider>
    <el-row type="flex" align="middle" style="height: 90%;">
      <el-col :span="6" :offset="4" style="height: 100%;">
        <artisan-group title="项目列表" style="height: 100%;">
          <draggable v-model="list" group="site" animation="100" dragClass="dragClass" chosenClass="chosenClass">
            <transition-group style="min-height: 100%; display: block">
              <div class="back-primary color-white padding7 margin5 align-center clickable" v-for="item in list"
                :key="item.projectId">
                {{ item.projectName }}({{ item.projectId }})
              </div>
            </transition-group>
          </draggable>
        </artisan-group>
      </el-col>
      <el-col :span="3" class="align-center" >
        <div>拖动排序</div>
        <img style="height: 10px; width: 70%;margin: 10px 0;" src="/img/rule/interval.png" />
        <el-button size="mini" type="success" icon="el-icon-check" @click="saveAllRules">
          保存顺序规则
        </el-button>
      </el-col>
      <el-col :span="6" style="height: 100%;">
        <artisan-group title="项目顺序规则" style="height: 100%;">
          <draggable v-model="rules" group="site" animation="100" dragClass="dragClass" chosenClass="chosenClass">
            <transition-group style="min-height: 500px; display: block">
              <div class="back-danger color-white padding7 margin5 align-center clickable" v-for="(item, index) in rules"
                :key="item.projectId">
                {{ index + 1 }}.{{ item.projectName }}({{ item.projectId }})
              </div>
            </transition-group>
          </draggable>
        </artisan-group>
      </el-col>
    </el-row>
  </base-container>
</template>

<script>
import prop from "./prop.js";
import draggable from "vuedraggable";
import { saveRules } from "@/api/jc/clinical-rule";
export default {
  components: { draggable },
  mixins: [prop],
  data() {
    return {
      drag: false,
      rule: {
        code: "order",
        projectId: "",
        projectName: "",
        relateProjectId: "",
        relateProjectName: "",
      },
      list: [],
    };
  },
  methods: {
    loaded(data) {
      let projectIds = data.map((c) => c.projectId);
      this.list = this.projects
        .filter((c) => projectIds.indexOf(c.id) < 0)
        .map((c) => {
          return {
            code: "order",
            projectId: c.id,
            projectName: c.name,
            duration: 0,
          };
        });
    },
    saveBefore(data) {
      data.rules.forEach((c, i) => {
        c.duration = i;
      });
    },
    saveAllRules() {
      let data = {
        code: this.code,
        rules: this.rules,
      };
      data.rules.forEach((c, i) => {
        c.duration = i;
      });
      this.loading = true;
      saveRules(data)
        .then(() => {
          this.loading = false;
          this.$message({ type: "success", message: "保存成功！" });
        })
        .catch(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style scoped>
.chosenClass {
  background-color: #f56c6c !important;
  opacity: 1 !important;
}

.dragClass {
  opacity: 1 !important;
  box-shadow: none !important;
  outline: none !important;
}
</style>
